const OFFICE_KEY = "office";

export const getLocalSelectedOffice = () => localStorage.getItem(OFFICE_KEY);
export const setLocalSelectedOffice = (office) => localStorage.setItem(OFFICE_KEY, office);
